module.exports = __webpack_public_path__ + "static/media/jumpy-block.ec016523.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/jumpy-block.png
// module id = 64
// module chunks = 0